import { ProductTypeCard } from '../../models';
import { ProductTypesRouteParams } from './product-type-base.component';

const normalize = (value: string | null | undefined): string =>
  value ? value.toLowerCase().trim() : '';

/**
 * Find the index of the card matching the route params.
 *
 * Plain product-type navigation passes the cat-class as the `:productType`
 * URL segment, which matches `card.ProductType` directly.
 *
 * Rented-As navigation from the Categories grid (RIE-16417) passes the
 * rented-as long-text as `:productType`. The grid rows are sourced from the
 * Postgres metrics-api while the cards still come from the SQL Server
 * rdo-api, and the two sources do not always render the long-text byte-for-
 * byte the same way. The matrix param `rentedAsCatClass` carries the
 * rented-as cat-class — a stable code that `selectProduct` itself uses as
 * the card's ProductType (see product-types.component.ts:231) — so falling
 * back to that match makes the lookup robust across the data-source split.
 */
export const findProductCardIndex = (
  cards: ReadonlyArray<ProductTypeCard>,
  params: ProductTypesRouteParams
): number => {
  if (!cards || cards.length === 0) {
    return -1;
  }
  const target = normalize(params.productType);
  const rentedAsCatClass = normalize(params.rentedAsCatClass);

  return cards.findIndex((card) => {
    if (!card) {
      return false;
    }
    const productType = normalize(card.ProductType);
    const description = normalize(card.Description);

    if (target && (productType === target || description === target)) {
      return true;
    }
    if (
      params.useRentedAsProductType &&
      rentedAsCatClass &&
      productType === rentedAsCatClass
    ) {
      return true;
    }
    return false;
  });
};
